/** Quiet, persistent marker. Must not look like an operational warning. */
export const PrototypeBadge = ({ className = "", compact = false }) => (
  <span className={`inline-flex h-6 items-center gap-1.5 rounded-md px-2 text-[12px] font-medium text-muted-foreground ${className}`} style={{ background: "hsl(var(--foreground) / 0.05)" }} data-testid="prototype-badge" title="Alle data i denne prototypen er fiktive">
    <span className="dot" style={{ background: "hsl(var(--state-neutral))" }} aria-hidden="true" />
    {compact ? "Demo" : "Demo · Eksempeldata"}
  </span>
);
